export function getRoot() {
  return process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : 'https://ezice.herokuapp.com';
}

export function getCookie(cname) {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  const expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export function daysAgo(timestamp) {
    const date1 = new Date(timestamp)
    const date2 = new Date()

    const timeDiff = date2.getTime() - date1.getTime();
    const dayDiff = timeDiff / (1000 * 3600 * 24);

    return dayDiff
  }